module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av7-34374b15911abad06143ba464be1255f.jpg";